// extracted by mini-css-extract-plugin
module.exports = {"navitem":"sidenav-item_navitem__3Et0y","active":"sidenav-item_active__vT27L"};